import React, { useState, useRef, useEffect } from "react";
import { producaov2 as api } from "../../../../services/apis";
import { Button, Form, Input, Divider } from "semantic-ui-react";
import TextEditor from "../../../../components/Admin/NewTextEditor";
import * as yup from "yup";
import { toast } from "react-toastify";
import Dropzone from "../../../../components/Admin/Dropzone";

import { Container, Content, Title, Field, Label } from "./styles";

import swal from "sweetalert";
import { Link, withRouter } from "react-router-dom";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";

import { isAuthAdmin } from "../../../../services/auth";

const CriarSimulado = (props) => {
  const description = useRef("");
  const [selectedFileImage, setSelectedFileImage] = useState("");
  const [selectedFileIntru, setSelectedFileIntru] = useState("");
  const [area, setArea] = useState([]);
  const imagem = useRef({
    image: "",
    instrucao: "",
  });
  const [simulado, setSimulado] = useState({
    titulo: "",
    area: "1",
    url: "",
  });

  useEffect(() => {
    loadAuth();
    loadArea();
  }, []);

  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };

  const loadArea = async () => {
    await api
      .get(`area-descricao`)
      .then((res) => {
        setArea(res.data);
      })
      .catch((err) => {
        swal("Não foi possível carregar as areas", err, "error");
      });
  };

  const create = async () => {
    if (selectedFileImage != "") {
      await uploadImage();
    }
    if (selectedFileIntru != "") {
      await uploadImageIntru();
    }

    const payload = {
      titulo: simulado.titulo,
      descricao: description.current,
      url: simulado.url,
      imagem: imagem.current.image,
      instrucao: imagem.current.instrucao,
      id_area_corporativa: simulado.area,
    };

    const simuladoValidation = await yup.object().shape({
      titulo: yup
        .string("Necessário que informe o titulo")
        .required("Necessário que informe o titulo"),
      descricao: yup
        .string("Necessário que informe a descrição")
        .required("Necessário que informe a descrição"),
      url: yup
        .string("Necessário que informe a url")
        .required("Necessário que informe a url"),
      id_area_corporativa: yup
        .string("Necessário que informe a area")
        .required("Necessário que informe a area"),
    });

    try {
      await simuladoValidation.validate(payload, { abortEarly: true });
      api
        .post(`/admin/simulado`, payload)
        .then(async (res) => {
          let logs = {
            local: "simulado",
            texto: `criou o simulado de id=${res.data.simulado.id}`,
          };
          await api.post("system_logs", { acao: JSON.stringify(logs) });
          swal(" Simulado salvo com sucesso", "", "success").then((res) =>
            props.history.push("/admin/simulados")
          );
        })
        .catch((err) => {
          swal("Não foi possível salvar o simulado", err, "").then((res) =>
            props.history.push("/admin/simulados")
          );
        });
    } catch (err) {
      if (err instanceof yup.ValidationError) {
        swal("Erro!", `${err}`, "error");
        return;
      }
    }
  };
  const uploadImage = async () => {
    try {
      const inputData = new FormData();

      inputData.append("file", selectedFileImage);
      inputData.append("path", `simulados`);

      await api.post(`/upload`, inputData).then((res) => {
        imagem.current["image"] = res.data.url;
      });

      toast.success("A operação foi concluida com sucesso!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } catch (err) {
      toast.error("A operação falhou, verifique o arquivo e tente novamente", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  const uploadImageIntru = async () => {
    try {
      const inputData = new FormData();

      inputData.append("file", selectedFileIntru);
      inputData.append("path", `simulados`);

      await api
        .post(`/upload`, inputData)
        .then((res) => (imagem.current["instrucao"] = res.data.url));

      toast.success("A operação foi concluida com sucesso!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } catch (err) {
      toast.error("A operação falhou, verifique o arquivo e tente novamente", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  return (
    <>
      <Container>
        <AdminMenu />
        <Content>
          <Title>Criar Simulado</Title>

          <Form>
            <Form.Group widths="equal">
              <Form.Field
                control={Input}
                label="Nome do Simulado"
                placeholder="Nome do Simulado"
                onChange={(e) => {
                  setSimulado({ ...simulado, titulo: e.target.value });
                }}
              />
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Field>
                <Label>Área</Label>
                <select
                  value={simulado.area}
                  onChange={(e) =>
                    setSimulado({ ...simulado, area: e.target.value })
                  }
                >
                  {area.map((are) => (
                    <option value={are.id_area}>{are.areacorp.nome_tab}</option>
                  ))}
                </select>
              </Form.Field>
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Field>
                <Label>Imagem</Label>
                <Dropzone onFileUploaded={setSelectedFileImage} />
              </Form.Field>
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Field>
                <Label>Instrução</Label>
                <Dropzone onFileUploaded={setSelectedFileIntru} />
              </Form.Field>
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Field
                control={Input}
                label="Url"
                placeholder="Url"
                onChange={(e) => {
                  setSimulado({ ...simulado, url: e.target.value });
                }}
              />
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Field>
                <Label>Qual o objetivo desse treinamento:</Label>
                <TextEditor
                  haveFullscreen
                  default={description.current}
                  text={description}
                />
              </Form.Field>
            </Form.Group>
            <Form.Group>
              <Form.Field
                control={Button}
                onClick={() => {
                  create();
                }}
              >
                Salvar
              </Form.Field>
              <Link to="/admin/simuladosdev">
                <Button color="secondary">Cancelar</Button>
              </Link>
            </Form.Group>
          </Form>
        </Content>
      </Container>
    </>
  );
};

export default withRouter(CriarSimulado);
